module.exports = __webpack_public_path__ + "media/components/assets/img/bg/circle-shape-br-e6be102a92cb0660736c0388d313d416.svg";